import DOMPurify from 'dompurify';
//functions
import { objectEmpty } from 'helper-functions-library';
import { getFrontPresentationSettingsPipe } from './functions/get-front-presentation-settings-pipe.js';
//helpers
import { otherConcept } from '../functions/otherConcept/otherConcept.js';
import { pluralConcepts } from '../functions/pluralConcepts/pluralConcepts.js';
import { capitalize } from 'helper-functions-library';
import {britishDate} from 'component-library';

//styles
import styles from './front-end-styles.css';
/*this component creates the presentation of each concept for the frontend of the site
Props:
	concept: the concept this is for
	frontend_pre_fix: any prefix to the title
	more_info_output: object of settings to display
	data: the data to present
*/
export function ConceptDisplay(props) {
	//set the variables
	let {
			concept, 
			data, 
			more_info_output
		} = props,
		other = otherConcept(concept),
		moreInfoOptions = {
			[concept+'_unique_id'] : 'URI',
			[concept+'_local_numbering'] : 'Local framework numbering',
			[concept+'_additional_info'] : 'More information', 
			[concept+'_status'] : 'Status',
			[concept+'_authority_to_change'] : 'Authority to change status', 
			[concept+'_date_accepted'] : 'Date accepted', 
			[concept+'_next_review'] : 'Date of next review',
			[other] : 'Linked '+other,
			'framework': 'Found in these frameworks',
			'category': 'Categories',
			'publication': 'New Research',
		},
		forTitle = {...moreInfoOptions, 'frameworks': 'Found in these frameworks', 'categories': 'Categories' }, //LEGACY to catch naming
		moreInfo = [],
		presentationOptions = more_info_output,
		homeURL = framework_info.homeURL ?? '';
		
	if (objectEmpty(presentationOptions)){
		presentationOptions = moreInfoOptions;
	}
	
/* TODO make the options dynamic
	baseMoreInfo = { 
		[other] : 'Linked '+capitalize(other)+'(s)',
		'framework': 'Found in the following Frameworks',
		'category': 'Categories',
	},
	tableSettingFrontOptions = getFrontPresentationSettingsPipe({concept:concept, tableSettings:framework_info.tableSettings}),
	options = {...baseMoreInfo, ...tableSettingFrontOptions},
*/

	//loop through the presentation options
	for (const name in presentationOptions) {
		//the contents
		let content = data?.[name];
		
		//LEGACY fix
		if (name == 'framework' && data['frameworks'] !== undefined) {
			content = data['frameworks'];
		}
		if (name == 'category' && data['categories'] !== undefined) {
			content = data['categories'];
		}
		
		if ( content == undefined || content == '' || content == null) {
			continue;
		}

		if ( name == 'framework' || name == 'frameworks' ) {
			if (!Array.isArray(content)) {
				content = Object.values(content);
			}
			content = <CommaSeperatedLinks content={content} name={'name'} />;

		}
		if ( name == 'category' || name == 'categories' ) {
			if (!Array.isArray(content)) {
				content = Object.values(content);
			}
			let catergoryCap = content.map(function(element, index) {
					//add the correct url
					element['url'] = homeURL+'/researchframework/v1/category/'+encodeURIComponent(encodeURIComponent(element['category']));
					element['category'] = capitalize(element['category']); //cap the cateogry name
					return element;
				});
			
			content = <CommaSeperatedLinks content={catergoryCap} name={'category'}/>; 
		}
		
		if ( name == other || name == pluralConcepts(other) ) {
			if (!Array.isArray(content)) {
				content = Object.values(content);
			}
			let otherWithNumbering = content.map(function(element, index) {
					//add the correct url
					element['url'] = homeURL+'/researchframework/v1/'+other+'/'+element[other+'_unique_id'];
					//checking for array is to avoid double adding of numbers and if not + local numbering, add that
					if( element[other+'_local_numbering'] !== undefined && element[other][other+'_local_numbering'] !== '' && !Array.isArray(element[other])) {
						element[other] = [element[other+'_local_numbering'],': ',element[other]];
					}
					return element;
				});

			content = <CommaSeperatedLinks content={otherWithNumbering} name={other}/>;
		}
		
		if ( name == 'publication' && !objectEmpty(data['publication']) ) {
			
			let publications = Object.values(data['publication']),
				formattedOther = publications.map(function(pub, index) {
					return <>
						<p>
						{index+1}. <a href={pub['publication_url']}>{pub['publication_name']}</a>, {pub['publication_published_date']} by {pub['publication_author']} - {pub['publication_relevance']}
						</p>
					</>;
				});

			content = formattedOther;
		}
			
		//if the option is 'addtional info', output html that is sanitized first
		if ( name == concept+'_additional_info') {
			content = <span className={styles.conceptMoreInfoContent} dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(data[name])}}/> 
		} 
		//URI
		if (name == concept+'_unique_id') {
			let url = homeURL+'/researchframework/v1/'+concept+'/'+data[name];
			content = <a href={url}>
						{url}
					</a>;
		}
		//if date convert dates to differnet format
		if ( name == concept+'_date_accepted' || name == concept+'_next_review' ) {
			content = britishDate(data[name]);
		} 

		//everything else is just output
		moreInfo.push(
			<>
				<h5 className={styles.conceptMoreInfoSubHeader} >{forTitle[name]}: </h5>
				<span className={styles.conceptMoreInfoContent}>{content}</span>	
			</>
		);
	}

	//return the details presentation
	return moreInfo; 
}

/*this componet converts an array to a comma seperated list of urls
Props:
	content: (array) the array to be converted
	name: (string) the name of the vairable 
*/
export function CommaSeperatedLinks(props) {
	let { content, name } = props;
	return content.map(returnLink, {name:name});
}

function returnLink(element, index, content) {
	let comma;
	//if the end, don't add comma
	if (index+1 !== content.length) {
		comma = <span>, </span>;
	}
	return <><a href={element.url}>{element[this.name]}</a>{comma}</>;
}